import React, { Component } from "react" ;
import Select from 'rc-select';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import 'rc-select/assets/index.css';
import locale from 'rc-pagination/lib/locale/tr_TR';
import TotalTable from "../../accounting/einvoice/TotalTable";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import axios from "axios";

class Footer extends Component{
	constructor(props){
		super(props);
		this.state = {
			fullContent: [],
			fullContentUrl: null,
			showTotal: false,
			loading: false
		};
		this.onShowSizeChange = this.onShowSizeChange.bind(this);
		this.onChange 		  = this.onChange.bind(this);
		this.fetchDataAll 	  = this.fetchDataAll.bind(this);
		this._fetchToken      = undefined;
	}

	componentDidMount() {
		this.setState({showTotal: false});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			this.setState({showTotal: false});
		}
	}

	componentWillUnmount() {
		if (typeof this._fetchToken !== typeof undefined) {
			this._fetchToken.cancel('unload')
		}
	}

	fetchDataAll() {
		let self = this;
		if (this.state.showTotal === true) {
			self.setState({
				showTotal: false
			});
			return;
		}

		if (typeof this._fetchToken !== typeof undefined) {
			this._fetchToken.cancel();
		}
		this._fetchToken = axios.CancelToken.source();

		let url = this.props.fetchDataUrl.url;

		url += '&isAll=true';

		let params = {
			url: url,
			method: "get",
			cancelToken: this._fetchToken.token
		};
		this.setState({loading: true});

		request(params)
			.then(function (response) {
				self.setState({
					fullContent: response.data.content,
					showTotal: true,
					loading: false
				});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	onShowSizeChange(current, pageSize) {
		if (isNaN(pageSize)) {
			current = 1;
			pageSize = this.props.total;
		}
		this.props.pageSize(current-1,pageSize);
	}

	onChange(current, pageSize) {
		this.props.pageSize(current-1,pageSize);
	}

	render(){
		return (
			<tfoot>
			{this.props.totalData &&
				<tr>
					<td colSpan={this.props.length} >
						<TotalTable page={this.props.page} content={this.props.content}
									documentType={this.props.documentType}/>
					</td>
				</tr>
			}
			{this.props.showTotalBtn &&
				<tr>
					<td colSpan={this.props.length}>
						<button
							style={{
								background: 'linear-gradient(rgba(154, 193, 218, 0.61), #6e8da2)'
							}}
							className="btn"
							onClick={this.fetchDataAll}>Kümülatif
							Toplam {!this.state.showTotal ? "Göster" : "Kaldır"}</button>
					</td>
				</tr>
			}
			{this.state.loading &&
				<tr>
					<td colSpan={this.props.length}>
						<span>Kayıtlar getiriliyor...</span>
					</td>
				</tr>
			}
			{this.state.showTotal && (
				<tr>
					<td colSpan={this.props.length}>
						<TotalTable showTotal={this.state.showTotal} page={"All"} content={this.state.fullContent}
									documentType={this.props.documentType}/>
					</td>
				</tr>
			)}
			<tr>
				<td colSpan={this.props.length}>
					<div className="col-sm-12 row pagi-footer-container" style={{justifyContent: "center"}}>
						<div className="col-sm-2"></div>
						<div style={{marginTop:'20px'}}>
							<Pagination
								selectComponentClass={Select}
								showSizeChanger
								showQuickJumper={this.props.isJumberEnabled}
								showTotal={(total) => `Kayıt Sayısı : ${total}`}
								defaultPageSize={this.props.size}
								hideOnSinglePage={!this.props.hide}
								pageSizeOptions={this.props.options}
								pageSize={this.props.size}
								onShowSizeChange={this.onShowSizeChange}
								onChange={this.onChange}
								total={this.props.total}
								className='pagi'
								locale={locale}
								showTitle={false}
								current={this.props.page+1}
								showLessItems
							/>
						</div>
						<div className="col-sm-2"></div>
						{this.props.tableType == "BayiList" &&
							<div style={{position:"absolute", top: 0, right: 0}}>
								Aktif Müşteri: {this.props.numberOfActiveCustomer} <br/>
								Pasif Müşteri: {this.props.numberOfPassiveCustomer} <br/>
								Toplam Müşteri: {this.props.numberOfActiveCustomer + this.props.numberOfPassiveCustomer}
							</div>}
					</div>
				</td>
			</tr>
			</tfoot>
		);
	}
}

export default Footer;